import { render, staticRenderFns } from "./ChannelParams.vue?vue&type=template&id=11d9d730&lang=pug"
import script from "./ChannelParams.vue?vue&type=script&lang=js"
export * from "./ChannelParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports